import getAll from 'utils/getAll'
import { apiUrls } from 'consts'
import { axiosGet } from 'shared/api/axios'

interface getRowsReturnType {
  filterRoles: Array<any>
  selectedFilterRole: any | null
}

const getRows = async (): Promise<getRowsReturnType> => {
  const filterRoles = await getAll(apiUrls.users + '/' + apiUrls.actionGetRoles)
  const selectedFilterRole = await axiosGet(
    apiUrls.users + '/' + apiUrls.actionGetSelectedFilterRole,
  )

  return {
    filterRoles: filterRoles,
    selectedFilterRole: selectedFilterRole,
  } as getRowsReturnType
}

export default getRows
